import { CompensationCalculatorAdapter } from "./CompensationCalculator";

export { CompensationCalculatorAdapter as CompensationCalculator };
